import { FC } from 'react';

import { RaaDialog } from 'raa-react';

const OfflineDialog: FC = () => {
  return (
    <RaaDialog
      header="Ingen anslutning"
      proceed={() => {
        window.location.reload();
      }}
      proceedButtonText="Ladda om sidan"
      ariaDescribedBy="dialog-description"
    >
      <p id="dialog-description" className="tw-my-4">
        Du är inte längre ansluten. Vänligen kontrollera din internetuppkoppling eller försök igen senare.
      </p>
    </RaaDialog>
  );
};

export default OfflineDialog;
